module.exports = __webpack_public_path__ + "img/project-5copy.ecffa191.jpg";